import React, { PropsWithChildren } from 'react';
import bem from '../../../../lib/bemUtils/bem';

import { appendClassName } from '../../../../lib/bemUtils/classname';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import { LiProps } from '../../../../types/HtmlProps';

export type ContentListItemProps = LiProps & {
  modifier?: Modifier<
    'border-left' | 'padding-10-top-bottom' | 'dragging' | 'no-padding' | 'no-padding-vertical' | 'padding-5'
  >;
  setFocus?: boolean;
  ref?: React.RefObject<HTMLLIElement | null>;
};

export function ContentListItem({
  children,
  modifier,
  className,
  ref,
  ...props
}: PropsWithChildren<ContentListItemProps>) {
  return (
    <li className={appendClassName(className, bem('content-list__item', modifier))} {...props} ref={ref}>
      {children}
    </li>
  );
}
